define.alias("shared/components/shared/schedule-navbar", "media/components/shared/schedule-navbar");